import React from 'react';
import { useLoading } from '../../context/LoadingContext';
import { useDevTools } from '../../context/DevToolsContext';
import FrostGlassLoader from '../FrostGlassLoader/FrostGlassLoader';

export default function LoadingScreen() {
  const { loading } = useLoading();
  const { loading: devLoading } = useDevTools();

  return (
    <FrostGlassLoader
      visible={loading || devLoading.forceGlobal}
      variant="global"
    />
  );
}
